import React from 'react';

import ExpensePackIcon from 'Assets/icons/expense-pack.svg';
import ExpenseTemplateIcon from 'Assets/icons/expense-template.svg';
import FolderIcon from 'Assets/icons/folder.svg';

/**
 * IB-875 — React port of resources/views/components/expenditure-line-type-legend.blade.php.
 *
 * Persistent legend for the R&E line-type indicators, rendered below both tables
 * on both views. Project is always shown; the Expense Template / Expense Pack
 * keys are gated on the corresponding event functions being enabled (matching
 * what can appear in the table).
 */
export default function RETypeIconLegend({ showTemplateKey = false, showPackKey = false }) {
    return (
        <div className="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-x-5 tw-gap-y-2 tw-text-xs tw-text-charcoal-75">
            <span className="tw-font-semibold tw-text-charcoal">{$t('Key:')}</span>
            <span className="tw-inline-flex tw-items-center tw-gap-x-1.5">
                <FolderIcon className="tw-w-3.5 tw-h-3.5 tw-shrink-0" />
                <span>{$t('Project')}</span>
            </span>
            {showTemplateKey && (
                <span className="tw-inline-flex tw-items-center tw-gap-x-1.5">
                    <ExpenseTemplateIcon className="tw-w-3.5 tw-h-3.5 tw-shrink-0" />
                    <span>{$t('Expense Template')}</span>
                </span>
            )}
            {showPackKey && (
                <span className="tw-inline-flex tw-items-center tw-gap-x-1.5">
                    <ExpensePackIcon className="tw-w-3.5 tw-h-3.5 tw-shrink-0" />
                    <span>{$t('Expense Pack')}</span>
                </span>
            )}
        </div>
    );
}
